<template>
  <div>
    <send-expiry-option-report-form
      :clientId="clientId"
      :lastParams="lastParams"
      v-model="reportFormOpen"
    />
    <page-toolbar>
      <undelivery-toolbar
        @change="onChange"
        @export="onExport"
        v-slot="slotProps"
        :marketId="marketId"
        :show-forward-option="false"
      >
        <kendo-button
          type="button"
          @click="onExport(slotProps.toolbar.getSelectedValues())"
          icon="excel"
          title="Export to Excel"
        />
        <kendo-button icon="window" title="Send Report" @click="openReportForm" />
      </undelivery-toolbar>
    </page-toolbar>
    <div class="text-xs-center">
      <v-progress-circular
        color="primary"
        :size="50"
        :width="8"
        :indeterminate="true"
        v-if="rendering"
      ></v-progress-circular>
      <v-progress-linear
        color="primary"
        height="14"
        :indeterminate="true"
        v-if="rendering"
      ></v-progress-linear>
    </div>
    <div ref="container" class="expiryOptionGrid" v-show="!rendering"></div>
  </div>
</template>
<script>
import PageToolbar from '@/components/PageToolbar'
import UndeliveryToolbar from '@/components/Report/UndeliveryToolbar'
import expiryOptionGrid from '@/dashboard-components/expiry-option-grid'
import SendExpiryOptionReportForm from '@/components/SendExpiryOptionReportForm'
import params from '@/helpers/params'
import {mapGetters} from 'vuex'
import security from '@/mixins/security'

export default {
  name: 'ExpiryOption',
  mixins: [security],
  data() {
    return {
      rendering: false,
      lastParams: null,
      clientId: 0,
      reportFormOpen: false,
    }
  },
  mounted() {
    this.$el.addEventListener('click', this.drilldownClick, false)
  },
  methods: {
    onChange(e) {
      const $container = kendo.jQuery(this.$refs.container)
      $container.empty()
      this.lastParams = e
      this.clientId = +this.selectedClientId

      this.rendering = true
      const vm = this
      expiryOptionGrid.render($container, this.lastParams, 'report').then(function() {
        vm.rendering = false
      })
    },
    onExport(e) {
      const qs = params.fromObject({
        t: this.tokenString,
        url: location.origin,
        ...e,
      })
      location.href = `/api/report/ExposureReport/exportExpiryOption?${qs}`
    },
    openReportForm() {
      this.reportFormOpen = true
    },
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({marketId: 'app/marketId'}),
    ...mapGetters({selectedClientId: 'authentication/selectedClientId'}),
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
  },
  components: {
    PageToolbar,
    UndeliveryToolbar,
    SendExpiryOptionReportForm,
  },
}
</script>

<style scoped>
.expiryOptionGrid {
  font-size: 0.9em;
}
</style>
